export default "__VITE_ASSET__DGdyVVJL__"